//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import userChecks from '~/mixins/userChecks';
export default {
  name: 'directActionsBlock',
  mixins: [userChecks],
  props: {
    resetLaptopAlign: {
      type: Boolean,
      default: false,
    },
    isDark: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    start() {
      if(this.hasRecurringSubscription()) {
        var alertObj = {};
        alertObj.type = 'info';
        alertObj.message = 'Je hebt al Meiden van Holland Direct. Geniet van onze sexfilms!';
        this.$store.commit('alertStore/setAlert', alertObj);
        return;
      }
      this.$store.commit('paywallStore/setView', 'active'); 
      this.$store.commit('subscriptionsStore/setPaywallToSubscription', 'direct');
      return;
    }
  }
};
